var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-full py-5 px-6 bg-white"},[_c('h3',{staticClass:"font-bold text-xl mt-4 text-gray-800"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }